module.exports = __webpack_public_path__ + "img/shape-metal_ay_mobile_hover@2x.4eed941a.png";